import { Card, CardContent, Grid, Link, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { FORGOT_EMAIL_PAGE_URL, HOME_PAGE_URL } from "@constants";
import { EmailVerificationForm } from "@features/EmailVerification/EmailVerificationForm";
import { EmailVerificationSuccess } from "@features/EmailVerification/EmailVerificationSuccess";

export enum EmailVerificationStep {
    initial,
    success,
}

export const EmailVerificationPage = () => {
    const [step, setStep] = useState(EmailVerificationStep.initial);
    const { t } = useTranslation("forgotEmail");

    const isInitialStep = step === EmailVerificationStep.initial;
    const isSuccessStep = step === EmailVerificationStep.success;

    return (
        <div className="container-boxed login__container">
            <Typography align="center" className="container-boxed__title" color="secondary" variant="h1">
                {isInitialStep && "Register"}
                {isSuccessStep && "Registration"}
            </Typography>
            <Card className="login__card" elevation={2}>
                <CardContent>
                    <Grid alignItems="center" container justifyContent="center" spacing={2}>
                        {isInitialStep && (
                            <Fragment>
                                <Grid item>
                                    <div className="login__helper">
                                        <Typography align="center" color="secondary" variant="normal">
                                            {t("emailVerification")}
                                            <br />
                                            {t("emailVerification2")}
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <EmailVerificationForm setStep={setStep} />
                                </Grid>
                            </Fragment>
                        )}
                        {isSuccessStep && (
                            <Grid item>
                                <EmailVerificationSuccess />
                            </Grid>
                        )}
                        <Grid className="login__links" item xs={12}>
                            <Link href={FORGOT_EMAIL_PAGE_URL}>
                                <Typography align="center" color="primary">
                                    {t("forgotEmail")}
                                </Typography>
                            </Link>
                            <Link href={HOME_PAGE_URL}>
                                <Typography align="center" color="primary">
                                    {t("backLogin")}
                                </Typography>
                            </Link>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    );
};
